import React from 'react';
import { House, Wrench, Sprout, Sparkles, Brush, ArrowUpRight } from 'lucide-react';
import { SERVICES } from '../data/site';
import { TESTIDS } from '../constants/testIds';

const ICONS = { House, Wrench, Sprout, Sparkles, Brush };

export const Services = () => {
  return (
    <section
      id="services"
      data-testid={TESTIDS.servicesSection}
      className="relative py-20 sm:py-28 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-14">
          <div className="lg:col-span-7">
            <span className="font-display uppercase tracking-[0.4em] text-xs text-[#E8B842]">
              / What we do
            </span>
            <h2 className="font-display uppercase font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mt-4">
              We specialise in <span className="text-[#E8B842]">roofline</span> work that lasts.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#A3A3A3] text-base sm:text-lg leading-relaxed">
              From a quick gutter clear to a full UPVC replacement, every job is approached
              the same way: turn up on time, do the work properly, leave the site tidy.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || House;
            return (
              <article
                key={s.title}
                data-testid={`${TESTIDS.serviceCard}-${i}`}
                className="group relative bg-[#0E0E0E] border border-[#E8B842]/15 hover:border-[#E8B842] p-8 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-14 h-14 bg-[#E8B842]/10 border border-[#E8B842]/30 flex items-center justify-center group-hover:bg-[#E8B842] transition-colors">
                    <Icon className="w-7 h-7 text-[#E8B842] group-hover:text-black transition-colors" />
                  </div>
                  <span className="font-display text-[#E8B842]/50 text-2xl tabular-nums">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display uppercase font-bold text-white text-2xl mb-2">
                  {s.title}
                </h3>
                <p className="font-display uppercase tracking-widest text-xs text-[#E8B842] mb-4">
                  {s.short}
                </p>
                <p className="text-[#C7C7C7] text-sm leading-relaxed">{s.description}</p>
                <ArrowUpRight className="absolute bottom-6 right-6 w-5 h-5 text-[#E8B842]/40 group-hover:text-[#E8B842] transition-colors" />
              </article>
            );
          })}

          {/* CTA tile */}
          <article className="relative bg-[#E8B842] text-black p-8 flex flex-col justify-between min-h-[260px]">
            <div>
              <h3 className="font-display uppercase font-extrabold text-3xl leading-tight">
                Not sure what you need?
              </h3>
              <p className="mt-3 text-sm leading-relaxed">
                Send a photo over WhatsApp or give Luke a ring &mdash; we&apos;ll talk you
                through it.
              </p>
            </div>
            <a
              href="#contact"
              data-testid="services-cta"
              className="mt-6 inline-flex items-center gap-2 bg-black text-[#E8B842] font-display font-bold uppercase tracking-wider px-6 py-3 self-start hover:bg-[#1A1A1A] transition-colors"
            >
              Get a free quote
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Services;
